import React, { useState } from 'react';
import * as C from '../../Onboarding/Common.styles';

import {validations} from '../../../../utils/validations';

const UserForm = ({register}) => {
    const [{userTitle, userName, userCompany, userEmail, userCountryCode, userNumber, userCity}, 
        setUserDetail ] = useState({
        userTitle: '',
        userName: '',
        userCompany: '',
        userEmail: '',
        userCountryCode: '+91',
        userNumber: '',
        userCity: ''
    });

    const [errors, setError] = useState({});

    const onChangeHandler = (field, value) => {
        const data = {
          userTitle,
          userName,
          userCompany,
          userEmail,
          userNumber,
          userCountryCode,
          userCity
        };
        data[field] = value;
        setUserDetail(data);
    }


    const regsiterUser  = (event) => {
        event.preventDefault();

        const formValidData = {
            userTitle,
            userName,
            userCompany,
            userEmail,
            userCountryCode,
            userNumber,
            userCity
        };

        const hasError = validateFields(formValidData);


        const data = {
            title: userTitle,
            full_name: userName,
            company_name: userCompany,
            email: userEmail,
            mobile: userCountryCode + userNumber,
            city: userCity
        };

        if (!hasError) {
            register(data);
        }
    }

    const fieldValidators = {
        'userTitle': {'field': 'title', 'fieldName': 'Title', 'validators': ['required']},
        'userName': {'field': 'fullName', 'fieldName': 'Name', 'validators': ['required', 'alpha']},
        'userCompany': {'field': 'userCompany', 'fieldName': 'Company', 'validators': ['required']},
        'userEmail': {'field': 'email', 'fieldName': 'Email', 'validators': ['required', 'validEmail']},
        'userNumber': {'field': 'mobile', 'fieldName': 'Mobile Number', 'validators': ['required', 'validMobileNumber']},
        'userCountryCode': {'field': 'mobilecode', 'fieldName': 'Mobile Code', 'validators': ['required', 'validMobileCode']},
        'userCity': {'field': 'city', 'fieldName': 'City', 'validators': ['required', 'alpha']}
      };
    
      const validateFields = (data) => {
        let errorObj = {};
        Object.keys(data).map(key => {
          if (fieldValidators[key]) {
            const validators = fieldValidators[key].validators;
            for (let i = 0; i < validators.length; i++) {
              const validateFunction = validations[validators[i]];
              const resp = validateFunction({
                value: data[key],
                fieldName: fieldValidators[key].fieldName,
                countryCode: userCountryCode
              });
              if (resp && !errorObj[key]) {
                errorObj[key] = resp;
              }
            }
          }
        });
        setError(errorObj);
        if (Object.keys(errorObj).length) {
          return true;
        }
        return false;
    }


    


    return(
        <C.FormMainWrapper>
            <C.WelcomeHeadText>Got a Question?</C.WelcomeHeadText>
            <C.HeadSubText>Enter your details to know more about myPartner!</C.HeadSubText>
            <C.FormWrapper>
                <C.UserInfoForm onSubmit={regsiterUser}>
                    <C.InputWrapper>
                        <C.TitleWrapper>
                            <C.CommonSelect
                                value={userTitle}
                                onChange={event => onChangeHandler('userTitle', event.target.value)}
                                hasError={errors['userTitle'] ? true : false}>
                                <option value="">Title</option>
                                <option value="1">Mr.</option>
                                <option value="2">Mrs.</option>
                                <option value="3">Ms.</option>
                            </C.CommonSelect>
                            
                            <C.ErrorText>{errors['userTitle']}</C.ErrorText>
                        </C.TitleWrapper>
                        <C.FullNameWrapper>
                            <C.CommonInput 
                                type="text"
                                name="fullName" 
                                value={userName} 
                                placeholder="Full Name."
                                onChange={event => onChangeHandler('userName', event.target.value)}
                                hasError={errors['userName'] ? true : false}
                            ></C.CommonInput>
                            <C.ErrorText>{errors['userName']}</C.ErrorText>
                        </C.FullNameWrapper>
                    </C.InputWrapper>
                    <C.InputWrapper>
                        <C.CommonInputWrap>
                            <C.CommonInput 
                                type="text" 
                                name="company"
                                value={userCompany} 
                                placeholder="Company Name"
                                onChange={event => onChangeHandler('userCompany', event.target.value)}
                                hasError={errors['userCompany'] ? true : false}
                            ></C.CommonInput>
                            <C.ErrorText>{errors['userCompany']}</C.ErrorText>
                        </C.CommonInputWrap>
                    </C.InputWrapper>
                    <C.InputWrapper>
                        <C.CommonInputWrap>
                            <C.CommonInput
                                type="email" 
                                name="email" 
                                value={userEmail} 
                                placeholder="Email Id"
                                onChange={event => onChangeHandler('userEmail', event.target.value)}
                                hasError={errors['userEmail'] ? true : false}
                            ></C.CommonInput>
                            <C.ErrorText>{errors['userEmail']}</C.ErrorText>
                        </C.CommonInputWrap>
                    </C.InputWrapper>
                    <C.InputWrapper>
                        <C.TitleWrapper>
                            <C.CommonInput 
                                type="text" 
                                name="code" 
                                value={userCountryCode} 
                                placeholder="+91"
                                disabled
                            ></C.CommonInput>
                        </C.TitleWrapper>
                        <C.FullNameWrapper>
                            <C.CommonInput 
                                type="text" 
                                name="number" 
                                value={userNumber} 
                                placeholder="Mobile Number"
                                onChange={event => onChangeHandler('userNumber', event.target.value)}
                                hasError={errors['userNumber'] ? true : false}
                            ></C.CommonInput>
                            <C.ErrorText>{errors['userNumber']}</C.ErrorText>
                        </C.FullNameWrapper>
                    </C.InputWrapper>
                    <C.InputWrapper>
                        <C.CommonInputWrap>
                            <C.CommonInput 
                                type="text" 
                                name="city" 
                                value={userCity} 
                                placeholder="City Name"
                                onChange={event => onChangeHandler('userCity', event.target.value)}
                                hasError={errors['userCity'] ? true : false} 
                            ></C.CommonInput>
                            <C.ErrorText>{errors['userCity']}</C.ErrorText>
                        </C.CommonInputWrap>
                    </C.InputWrapper>
                    <C.ButtonWrapper>
                        <C.SignUpBtn type="submit">Request a Call Back</C.SignUpBtn>
                    </C.ButtonWrapper>
                </C.UserInfoForm>
            </C.FormWrapper>
        </C.FormMainWrapper>
    );
}

export default UserForm;